import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { setReset, setCurrentQuery } from "../state/app"
const Filters = ({
  dispatch,
  difficulties,
  styles,
  difficulty,
  style,
  difficultyFilter,
  styleFilter,
  currentQuery,
}) => {
  const [bodyEl, setBodyEl] = useState(null)
  const [gatsbyEl, setGatsbyEl] = useState(null)
  const [filtersEl, setFiltersEl] = useState(null)
  const [filtersFab, setFiltersFab] = useState(null)

  useEffect(() => {
    setBodyEl(document.querySelector("body"))
    setGatsbyEl(document.querySelector("#___gatsby"))
    setFiltersEl(document.querySelector(".filters"))
    setFiltersFab(document.querySelector(".filters-fab"))
  }, [])

  useEffect(() => {
    // console.log(`Current Query from filters`, currentQuery);
    if (currentQuery !== "") {
      closeFilters()
    }
  }, [currentQuery])

  const closeFilters = () => {
    if (hasClass(bodyEl, "overflow-hidden")) {
      bodyEl.classList.remove("overflow-hidden")
    }
    if (hasClass(gatsbyEl, "overflow-hidden")) {
      gatsbyEl.classList.remove("overflow-hidden")
    }
    if (hasClass(filtersEl, "filters-opened")) {
      filtersEl.classList.remove("filters-opened")
    }
    if (hasClass(filtersFab, "hide")) {
      filtersFab.classList.remove("hide")
    }
  }

  const openFilters = () => {
    bodyEl.classList.add("overflow-hidden")
    gatsbyEl.classList.add("overflow-hidden")
    filtersEl.classList.add("filters-opened")
    filtersFab.classList.add("hide")
  }

  const reset = () => {
    dispatch(setReset(true))
    dispatch(setCurrentQuery(""))
    closeFilters()
  }

  const hasClass = (el, classname) => {
    if (el == null) return false

    return el.classList.contains(classname)
  }

  return (
    <div>
      <div className="filters">
        <div className="container filters-container">
          <div className="row justify-content-center filters-content">
            {/* Close button */}
            <div
              className="filters-close-icon"
              onClick={closeFilters}
              onKeyDown={closeFilters}
              role="button"
              tabIndex={0}
              aria-label="Fermer les filtres"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.1281 16.6312C32.1281 16.425 31.9594 16.2562 31.7531 16.2562L28.6594 16.2703L24 21.825L19.3453 16.275L16.2469 16.2609C16.0406 16.2609 15.8719 16.425 15.8719 16.6359C15.8719 16.725 15.9047 16.8094 15.9609 16.8797L22.0594 24.1453L15.9609 31.4062C15.9043 31.4749 15.8729 31.5609 15.8719 31.65C15.8719 31.8562 16.0406 32.025 16.2469 32.025L19.3453 32.0109L24 26.4562L28.6547 32.0062L31.7484 32.0203C31.9547 32.0203 32.1234 31.8562 32.1234 31.6453C32.1234 31.5562 32.0906 31.4719 32.0344 31.4015L25.9453 24.1406L32.0438 16.875C32.1 16.8094 32.1281 16.7203 32.1281 16.6312Z"
                  fill="black"
                />
                <path
                  d="M24 3.04688C12.4031 3.04688 3 12.45 3 24.0469C3 35.6437 12.4031 45.0469 24 45.0469C35.5969 45.0469 45 35.6437 45 24.0469C45 12.45 35.5969 3.04688 24 3.04688ZM24 41.4844C14.3719 41.4844 6.5625 33.675 6.5625 24.0469C6.5625 14.4188 14.3719 6.60938 24 6.60938C33.6281 6.60938 41.4375 14.4188 41.4375 24.0469C41.4375 33.675 33.6281 41.4844 24 41.4844Z"
                  fill="black"
                />
              </svg>
            </div>

            {/* Select Container */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              {/* Difficulty */}
              <div className="form-group">
                <select
                  className="form-control"
                  value={difficulty}
                  onChange={difficultyFilter}
                  aria-label="Sélectionner une Difficulté"
                  tabIndex={0}
                >
                  <option value="">Choisir une difficulté</option>
                  {difficulties.map(({ node }) => {
                    return (
                      <option
                        value={node.name}
                        key={node.wordpress_id}
                        dangerouslySetInnerHTML={{ __html: node.name }}
                      ></option>
                    )
                  })}
                </select>
              </div>

              {/* Style */}
              <div className="form-group">
                <select
                  className="form-control"
                  value={style}
                  onChange={styleFilter}
                  aria-label="Sélectionner un style"
                  tabIndex={0}
                >
                  <option value="">Choisir un style</option>
                  {styles.map(({ node }) => {
                    return (
                      <option
                        value={node.name}
                        key={node.wordpress_id}
                        dangerouslySetInnerHTML={{ __html: node.name }}
                      ></option>
                    )
                  })}
                </select>
              </div>

              {/* Bouton reset */}
              <div className="form-group">
                <button className="btn btn-danger" onClick={reset} tabIndex={0}>
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="filters-fab d-lg-none"
        onClick={openFilters}
        role="button"
        tabIndex={0}
        aria-label="Filtres"
      >
        <svg
          className="filters-fab__icon"
          idth="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 24H12V21.3333H4V24ZM4 8V10.6667H28V8H4ZM4 17.3333H20V14.6667H4V17.3333Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  )
}

export default connect(
  state => ({
    currentQuery: state.app.currentQuery,
  }),
  null
)(Filters)
